import React from 'react';
import slugify from 'slugify';

class StorePicker extends React.Component {
	/**constructor() {
		super();
		this.goToStore = this.goToStore.bind( this );
	}**/
	goToStore(event) {
		event.preventDefault();
		// first grab the text from the box
		const storeId = this.storeInput.value;
		this.context.router.transitionTo(`/store/${slugify(storeId)}`)
		// second we're going to transition to / to /store/:storeId

	}

	render() {
		return (
			<form className="store-selector" onSubmit={(e) => this.goToStore(e)}>
				<h2>Please Enter A Store Name</h2>
				<input type="text" required placeholder="Store Name" ref={(input) => { this.storeInput = input}} />
				<button type="submit">Visit Store -></button>
			</form>
		)
	}
}

StorePicker.contextTypes = {
	router: React.PropTypes.object
}

export default StorePicker;


/** WEBPACK FOOTER **
 ** ./src/components/StorePicker.js
 **/